import { api } from "../rtk";
import { ENDPOINTS } from "../url";

export const stripeApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getStripePlans: builder.query({
            query: (params) => ({
                url: ENDPOINTS.STRIPE_PLANS,
                method: "GET",
                params,
            }),
            providesTags: ["StripePlans"],
        }),
        createStripePlan: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.STRIPE_PLANS,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["StripePlans"],
        }),
        getStripePlanDetail: builder.query({
            query: (id) => ({
                url: `${ENDPOINTS.STRIPE_PLANS}${id}`,
                method: "GET",
            }),
            providesTags: ["StripePlans"],
        }),
        updateStripePlan: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${ENDPOINTS.STRIPE_PLANS}${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["StripePlans"],
        }),
        deleteStripePlan: builder.mutation({
            query: (id) => ({
                url: `${ENDPOINTS.STRIPE_PLANS}${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["StripePlans"],
        }),
    }),
    overrideExisting: false,
});

export const { useGetStripePlansQuery, useCreateStripePlanMutation, useGetStripePlanDetailQuery, useUpdateStripePlanMutation, useDeleteStripePlanMutation } = stripeApi;
